import React from 'react'
import { AsyncCreatable, Async } from 'react-select'

import enhance from './enhance'
import { Wrapper, Icon, Label } from './styles'
import './react-select-customized.css'
import debouncePromise from 'debounce-promise'
import { useCallback } from 'react'

const InputAutoComplete = ({
  input: { onChange, value, ...restInput },
  meta: { visited, touched, error, ...restMeta },
  showLabel,
  label,
  beforeIcon,
  handleChange,
  handleFocus,
  handleBlur,
  selectValue,
  innerRef,
  selectedValue,
  handleKeyDown,
  isCreatable,
  dropDown = true,
  handleClearSearch,
  loadOptions,
  noResultsText,
  searchPromptText,
  ...rest
}) => {
  const debouncedLoadOptions = useCallback(debouncePromise(loadOptions, 300), [
    loadOptions,
  ])

  return (
    <Wrapper
      onClick={handleClearSearch}
      className={(beforeIcon && 'hasIcon') || ''}
      dropDown={dropDown}
    >
      {beforeIcon && <Icon name={beforeIcon} />}
      {label && (
        <Label visited={showLabel || visited || value} className="label">
          {label}
        </Label>
      )}
      {React.createElement(isCreatable ? AsyncCreatable : Async, {
        ref: innerRef,
        className: (beforeIcon && 'hasIcon') || '',
        arrowRenderer: null,
        onChange: handleChange,
        value: selectedValue,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onInputKeyDown: handleKeyDown,
        inputProps: {
          'data-testid': rest['data-testid'],
        },
        loadOptions: debouncedLoadOptions,
        noResultsText: noResultsText || 'Type to search',
        searchPromptText: searchPromptText || 'Type to search',
        ...rest,
      })}
    </Wrapper>
  )
}

export default enhance(InputAutoComplete)
